import React from "react";
import { CLIENT_USER_INFO } from "../../constants/updateClientContants";
import UpdateClientProfilesWrapper from "../../container/UpdateClientProfilesWrapper/UpdateClientProfilesWrapper";

const UpdateClientInfo = () => (
  <UpdateClientProfilesWrapper bodyContent={CLIENT_USER_INFO} />
);

export default UpdateClientInfo;
